import Button from "@components/Button";
import ScalableWrapper from "@components/ScalableWrapper";
import View from "@components/View";
import { images } from "@utils/media";
import { useState } from "react";

const instructions = [
  {
    title: "Tutorial 1",
    description:
      "The AI host pits you against your friends in a battle for survival!",
    image: images.HowToPlayTutorial1,
  },
  {
    title: "Tutorial 2",
    description:
      "Each round the AI asks a question, you submit pathetic answers, and everyone votes.",
    image: images.HowToPlayTutorial2,
  },
  {
    title: "Tutorial 3",
    description:
      "Players with the least votes get eliminated and the last player wins the mystery prize!",
    image: images.HowToPlayTutorial3,
  },
];

const HowToPlayPopup = (props: { closePopup: () => void }) => {
  const { closePopup } = props;

  const [currentIndex, setCurrentIndex] = useState(0);

  return (
    <View className="w-screen h-dvh absolute top-0 left-0 z-[999999] font-[Slackey]">
      <View
        enableEventCapturing
        className="w-full h-full absolute top-0 left-0 bg-black/60"
      />
      <ScalableWrapper maintainAspectRatioBy="height">
        <View className="w-full h-full flex items-center justify-center">
          <View
            enableEventCapturing
            className="relative bg-[#F72EC5] w-[32rem] h-[29rem] p-1.5 rounded-xl flex flex-col items-center"
          >
            <Button
              className="bg-transparent border-none outline-none absolute -top-4 -right-4"
              onClick={closePopup}
            >
              <img
                src={images.ClosePopupIcon}
                alt="close-popup"
                className="w-8 h-8 object-contain"
              />
            </Button>
            <h1
              className="text-white mt-0.5 mb-2"
              style={{ textShadow: "0px 3.1px 0px rgba(0, 0, 0, 1)" }}
            >
              How to Play
            </h1>
            <View className="relative w-full h-full flex flex-col bg-[#0C2450] rounded-b-xl py-3 overflow-hidden">
              <View className="w-full flex px-3">
                {instructions.map((instruction, index) => (
                  <View
                    key={instruction.title}
                    className={`w-full h-full ${
                      index === currentIndex ? "flex" : "hidden"
                    }`}
                  >
                    <img
                      src={instruction.image}
                      alt={instruction.title}
                      className="w-full aspect-video object-contain"
                    />
                  </View>
                ))}
              </View>
              <View className="w-full h-8 flex items-center justify-center gap-2">
                {instructions.map((instruction, index) => (
                  <View
                    key={instruction.title}
                    className={`w-2.5 h-2.5 bg-white rounded-full ${
                      index === currentIndex ? "opacity-100" : "opacity-50"
                    }`}
                  />
                ))}
              </View>
              <View className="w-full h-16 flex items-center justify-center px-5">
                {instructions.map((instruction, index) => (
                  <View
                    key={instruction.title}
                    className={`bg-[#FFED45] border-4 border-solid border-[#FFB218] rounded-xl text-black w-full h-16 flex items-center justify-center px-3 ${
                      index === currentIndex ? "flex" : "hidden"
                    }`}
                    style={{
                      boxShadow: "0px 4px 0px 0px #F72EC5",
                    }}
                  >
                    <p className="font-mono font-bold text-center text-sm">
                      {instruction.description}
                    </p>
                  </View>
                ))}
              </View>
              <View className="absolute top-0 left-0 w-full h-full flex justify-between px-2 py-28">
                <Button
                  className="w-12 h-12 bg-transparent border-none outline-none"
                  onClick={() => {
                    setCurrentIndex(currentIndex - 1);
                  }}
                  disabled={currentIndex === 0}
                >
                  <img
                    src={images.LeftArrowIcon}
                    alt="left-arrow"
                    className={`w-12 h-12 object-contain ${
                      currentIndex === 0 ? "opacity-0" : "opacity-100"
                    }`}
                  />
                </Button>
                <Button
                  className="w-12 h-12 bg-transparent border-none outline-none"
                  onClick={() => {
                    setCurrentIndex(currentIndex + 1);
                  }}
                  disabled={currentIndex === instructions.length - 1}
                >
                  <img
                    src={images.RightArrowIcon}
                    alt="left-arrow"
                    className={`w-12 h-12 object-contain ${
                      currentIndex === instructions.length - 1
                        ? "opacity-0"
                        : "opacity-100"
                    }`}
                  />
                </Button>
              </View>
            </View>
          </View>
        </View>
      </ScalableWrapper>
    </View>
  );
};

export default HowToPlayPopup;
